<div class="user-profile-form" fxLayout="column">
  <div fxLayout="row" fxLayoutGap="15px">
    <mtn-text-field [form]="form" controlName="firstName"
                    [placeholder]="'USER_PROFILE.FIRST_NAME' | translate">
    </mtn-text-field>
    <mtn-text-field [form]="form" controlName="lastName"
                    [placeholder]="'USER_PROFILE.LAST_NAME' | translate">
    </mtn-text-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <mtn-text-field [form]="form" controlName="title"
                    [placeholder]="'USER_PROFILE.TITLE' | translate">
    </mtn-text-field>
    <mtn-phone-number-field [form]="form" controlName="phoneNumber">
    </mtn-phone-number-field>
  </div>
</div>
